<template>
    <section>
        <div class="lives">
            <div class="lives-top">
                <div style="height:28px;">
                    <img src="@/assets/images/home/p3.png" alt="">
                </div>
                <div class="titles">{{ $t('lives.Lives.603275-0') }}</div>
            </div>
            <ul class="lives-ul" v-if="!$utils.isArrayEmpty(livesList)">
                <li v-for="(item,index) in livesList" :key="index" @click="goLivesDetail(item.liveUrl)">
                    <div class="live-left">
                        <p class="p1">{{item.title}}</p>
                        <p class="p2">{{ $t('lives.Lives.603275-1') }}{{item.author}}</p>
                        <span>{{item.description}}</span>
                    </div>
                    <div class="live-right">
                        <span>{{ $t('lives.Lives.603275-2') }}</span>
                        <p class="p3">{{item.startTime}}</p>
                        <p class="p3">{{item.endTime}}</p>
                    </div>
                </li>
            </ul>
            <div class="nodata" v-else>
                {{ $t('lives.Lives.603275-3') }}
            </div>
            <div class="page">
                <pagination
                    :pageSize="params.rows"
                    :pageSizes="pageSizes"
                    :currentPage="params.page"
                    :total="total"
                    @current-change="changePage"
                    @size-change="sizeChange"
                    style="margin-top:12px;"
                    >
                </pagination>
            </div>
        </div>
    </section>
</template>
<script>
import pagination from "components/pagination/index.vue";
import * as api_home from 'service/api/methods/api_home'
export default { 
    components:{
        pagination
    }, 
    data(){
        return{
            params:{
                page:1,
                rows:15
            },
            total:0,
            pageSizes:[10, 15, 20, 25,30],
            livesList:[]
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            this.getpageList(this.params);
        },
        changePage(val){
            this.params.page = val;
            this.getData();
        },
        sizeChange(val){
            this.params.page = 1;
            this.params.rows = val;
            this.getData();
        },
        getpageList(params){//直播预告列表
            api_home.getpageList(params).then((res)=>{
                if(this.$utils.isArrayEmpty(res.data.records) && (res.data.total > 0)){
                    this.params.page=1;
                    this.getData();
                }
                this.livesList=res.data.records;
                this.total=res.data.total;
            }).catch(()=>{
                this.livesList=[];
            })
        },
        goLivesDetail(liveUrl){
            window.open(liveUrl,'_blank');
        }
    }
    
}
</script>
<style lang="less" scoped>
section{
    width:100%;
    position: absolute;
    min-height: calc(100% - 66px);
    background: #fff;
    .lives-top{
        width:100%;
        background: #fff;
        padding:27px 0 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        .titles{
            margin:0 26px 0 5px;
            font-size: 18px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            color: #333333;
        }
        img{
            width:28px;
            height: 28px;
        }
    }
    .lives{
        width:1200px;
        margin:0 auto;
        .lives-ul{
            li{
                padding:20px 0 20px 0;
                border-bottom: 1px solid #cccccc;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer; 
                font-size: 13px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #666666;
                .live-left{
                    width:767px;
                }
                .live-right{
                    width:160px;
                    text-align: center;
                    .p3{
                        font-size: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        color: #009A3E;
                    }
                }
                .p1{
                    font-weight: 700;
                    color: #333333;
                    margin-bottom:10px;
                }
                .p2{
                    margin-bottom:7px;
                }
            }
        }
        .nodata{
            min-height: 600px;
            line-height: 600px;
            text-align: center;
            color:#999;
        }
        .page{
            padding: 20px 0 50px 0;
            text-align: center;
        }
    }
}
</style>